module.exports = __webpack_public_path__ + "assets/img/subtraction_icon.5ab86975.svg";